import { useEffect, useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import { useAppSelector } from 'store/store-hooks';
import styles from './_style.module.scss';

export const PpPlayer = () => {
  const { files } = useAppSelector((state) => state.app__files);
  const { file, playing } = useAppSelector((state) => state.pp);
  const [url, setUrl] = useState('');
  const playerRef = useRef<ReactPlayer>(null);

  useEffect(() => {
    if (!file) return;
    setUrl(files[file].fileWithEffectsUrls.fileUrl ?? '');
    console.log(playerRef.current?.getInternalPlayer());
  }, [file]);

  useEffect(() => {
    console.log(playerRef.current);
  }, []);

  return (
    <div className={styles.Player}>
      <ReactPlayer
        ref={playerRef}
        playing={playing}
        className={styles.Player__el}
        onReady={() => console.log('__onReady')}
        url={url}
      />
    </div>
  );
};
